/**
 * "SDKs" documentation section.
 *
 * The server-side intent-verification SDKs: an overview presenting all eight
 * languages (Node plus seven non-Node), then one page per non-Node SDK,
 * generated by the shared factory so every page stays structurally identical
 * and the i18n surface stays bounded. Node itself is covered by the quickstart
 * (`@syncanix/sdk-node`), which the overview links to. Every SDK verifies the
 * same HMAC intent envelope documented in `reference/runtime-api`.
 */
import { SDKS_OVERVIEW_PAGE } from './pages/sdks-overview.page';
import { SDK_GUIDES, sdkGuidePage } from './pages/sdks.factory';

import type { DocSection } from './types';

export const SDKS_SECTION: DocSection = {
  id: 'sdks',
  titleKey: 'docs.section.sdks.title',
  pages: [SDKS_OVERVIEW_PAGE, ...SDK_GUIDES.map(sdkGuidePage)],
};
